import * as PIXI from 'pixi.js'

import objBg from './_objBg.es6'
import objText from './_objText.es6'
import objDeco from './_objDeco.es6'
import objCopy from './_objCopy.es6'

export default class Canvas {
    constructor() {
        this.app = null
        this.container = null

        this.init()
    }

    init() {
        this.createPixi()
    }

    createPixi() {
        const generator = document.querySelector('.js-generator')
        const canvasH = 630
        const canvasW = 1200

        this.app = new PIXI.Application({
            width: canvasW,
            height: canvasH,
            backgroundColor: 0x000000,
            preserveDrawingBuffer: true,
            transparent: true,
            //resolution: devicePixelRatio, //retina対応
            autoDensity: true, //retina対応
        })

        this.app.view.setAttribute('id', 'l-generator')
        generator.appendChild(this.app.view)

        const container = new PIXI.Container()
        container.sortableChildren = true
        this.app.stage.addChild(container)
        this.factory(container)

    }

    factory(container) {
        //オブジェクトの生成
        this.objbg = new objBg(this.app, container)
        this.objtext = new objText(this.app, container)
        this.objdeco = new objDeco(this.app, container)
        this.objcopy = new objCopy(this.app, container)
    }

    createImage() {
        const imgUrl = this.app.view.toDataURL('image/png')
        const img = document.getElementById('canvas_image')
        img.src = imgUrl
    }

    destroy() {
        document.getElementById('l-webgl') && document.getElementById('l-webgl').remove()
        this.app.destroy()
    }
}
